import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllPlans: {
		id: 'navigation-apps-sidebar-nav4-plans.plans.common.footer.view-all-plans',
		defaultMessage: 'View all plans',
		description: 'Message for the view all plans menu item in the plans submenu',
	},
});
